<template>
  <div>
    <alert
      v-if="alertVisible"
      :message="alertMessage"
      :type="alertType">
    </alert>
    <main-layout
      controlsBg="light"
      customControls
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row column-align="center">
          <grid-col col-size="4">
            <div class="header-wrapper margin-top-xl margin-bottom-xxl">
              <div class="title-wrapper">
                <h1 class="header header-title">
                  <chevron
                    @click="$router.push({name: 'Workspace'})"/>
                  {{ $t('menu.glucoseEntryTittle') }}
                </h1>
              </div>
            </div>
          </grid-col>
        </grid-row>

        <grid-row
          column-align="center">
          <grid-col col-size="4">
            <h2 class="margin-bottom-s">
              {{ $t('menu.glucoseUploaderTittle') }}: {{ getUserAccount.username }}.{{ $t('menu.glucoseEntry') }} </h2>
            <h4>{{ $t('menu.glucoseFile') }} </h4>
          </grid-col>
        </grid-row>
        <br>
        <grid-row column-align="center">
          <DropZone v-on:uploaded="uploadCsv"></DropZone>
        </grid-row>
        <br>

      </div>
    </main-layout>
    <add-user-modal
      v-if="showModal"
      :users="users"
      v-on:addUser="addUser"
      v-on:cancel="showModal = false"/>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import BtnInputFile from '@/components/shared/buttons/BtnInputFile';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Alert from '@/components/shared/alert/Alert';
import Chevron from '@/components/shared/Chevron';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Radio from '@/components/shared/forms/Radio';
import AddUserModal from '@/components/group/AddUserModal';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faUsers} from '@fortawesome/pro-regular-svg-icons';
import userApi from '@/api/user';
import csvIngestApi from '@/api/csvIngest';
import {mapGetters} from 'vuex';
import DropZone from '../../../components/shared/DropZone';

export default {
  name: 'CsvIngest',
  components: {
    DropZone,
    AddUserModal,
    Radio,
    BtnPill,
    Chevron,
    MainLayout,
    GridRow,
    GridCol,
    BtnInputFile,
    Alert,
    FontAwesomeIcon
  },

  data () {
    return {
      dropzoneFile: {},
      showModal: false,
      selectedUser: null,
      users: [],
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success
      icon: {
        users: faUsers
      }
    };
  },
  created () {
    userApi.getUsers(this).then((users) => {
      this.users = users.filter(user => user.enabled);
    });
  },
  computed: {
    ...mapGetters([
      'getUserAccount'
    ]),
    getBreadcrumb () {
      return [
        {name: this.$t('menu.workspace'), link: '/workspace'},
        {name: this.$t('menu.csvIngest'), disabled: true}
      ];
    }
  },
  methods: {
    uploadCsv (filelist) {
      csvIngestApi.uploadGlucose(this, this.getUserAccount.username, filelist[0]).then(() => {
        this.alertVisible = true;
        this.alertMessage = this.$t('menu.glucoseGood');
        this.alertType = 'success';
        setTimeout(() => {
          this.alertVisible = false;
        }, 2500);
      }).catch(() => {
        this.alertVisible = true;
        this.alertMessage = this.$t('menu.glucoseError');
        this.alertType = 'error';
        setTimeout(() => {
          this.alertVisible = false;
        }, 2500);
      });
    },
    addUser (user) {
      this.showModal = false;
      this.selectedUser = user;
    },
    showAlert (message, type) {
      this.alertVisible = true;
      this.alertMessage = message;
      this.alertType = type;
      setTimeout(() => {
        this.alertVisible = false;
      }, 2000);
    }
  }
};
</script>

<style lang="scss">
@import "src/stylesheets/variables";
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/GlucoseUploader.vue